var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('MsgEdit',{attrs:{"row":_vm.row,"msg-level-options-in":_vm.msgLevelOptions,"msg-type-options-in":_vm.msgTypeOptions,"is-read-only":_vm.readOnly},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }